import { Box } from '@mui/material';
import React from 'react';

import type { MarketplaceService } from '../../../types/pricing';
import ComparisonSection from './ComparisonSection';
import FaqSection from './FaqSection';
import HighlightsSection from './HighlightsSection';
import HowItWorksSection from './HowItWorksSection';
import IncludesSection from './IncludesSection';

type ServiceSection =
  | { type: 'highlights'; title?: string; items?: string[] }
  | { type: 'includes'; title?: string; items?: string[] }
  | { type: 'how_it_works'; title?: string; steps?: Array<{ title: string; text: string }> }
  | { type: 'faq'; title?: string; items?: Array<{ q: string; a: string }> }
  | { type: 'comparison'; title?: string; columns?: string[]; rows?: string[][] };

const ServiceSections: React.FC<{ service: MarketplaceService }> = ({ service }) => {
  const sections = ((service as any)?.metadata?.sections || []) as ServiceSection[];
  if (!Array.isArray(sections) || sections.length === 0) return null;

  return (
    <Box sx={{ mt: 3 }}>
      {sections.map((section, index) => {
        const key = `${section.type}-${index}`;

        switch (section.type) {
          case 'highlights':
            return <HighlightsSection key={key} title={section.title} items={section.items} />;
          case 'includes':
            return <IncludesSection key={key} title={section.title} items={section.items} />;
          case 'how_it_works':
            return <HowItWorksSection key={key} title={section.title} steps={section.steps} />;
          case 'faq':
            return <FaqSection key={key} title={section.title} items={section.items} />;
          case 'comparison':
            return (
              <ComparisonSection
                key={key}
                title={section.title}
                columns={section.columns}
                rows={section.rows}
              />
            );
          default:
            return null;
        }
      })}
    </Box>
  );
};

export default React.memo(ServiceSections);
